import * as React from 'react';

/**
 * Hook that handles Escape key press detection.
 * Adds a keydown listener when isActive is true, and removes it on cleanup.
 *
 * @param callback - Function to call when Escape is pressed
 * @param isActive - Whether the listener should be active
 */
export function useEscapeKey(
  callback: () => void,
  isActive: boolean
): void {
  React.useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        callback();
      }
    };

    if (isActive) {
      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [isActive, callback]);
}
